module.exports = {
      id: "account-notification-usage",
      viewBox: "0 0 18.1 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#account-notification-usage",
      toString: function () {
        return this.url;
      }
    }